import styled from "styled-components";
import theme from "components/shared/theme";

export const Body = styled.div`
  background-color: ${theme.colors.blackDefault};
  height: 64px;
  align-items: center;
  .container {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 0px;
    padding-right: 0px;
    justify-content: space-between;
    @media screen and (max-width: 575px) {
      padding-left: 10px;
      padding-right: 10px;
    }
    @media screen and (min-width: 1216px) {
        max-width: 1152px !important;
    }
    @media screen and (min-width: 1024px) {
        max-width: 960px;
    }
  }
`;

export const ImgIcon = styled.img`
  width: 44px;
  height: 34px;
`;

export const MenuOptions = styled.ul`
  list-style-type: none;
  background-color: ${theme.colors.blackDefault};
  list-style: none;
  border: none;
  margin: 0px;
  padding-left: ${props => (props.responsive ? "15px" : "")};
  a {
    text-decoration: none;
    color: none;
    :hover {
      text-decoration: none;
    }
  }
`;
export const Option = styled.li`
  display: ${props => (props.responsive ? "" : "inline")};
  margin-left: ${props => (props.responsive ? "" : "26px")};
  color: ${props => (props.noColor ? "white" : theme.colors.greenDefault)};
  font-weight: 700;
  font-size: 14px;
  background-color: ${props =>
    props.responsive ? theme.colors.blackDefault : ""};
  padding-top: 10px;
  padding-bottom: 10px;
`;
